"use client";

import { motion } from "framer-motion";
const showcaseFeatures = [{
  title: "AI-Powered Strategy Generation",
  description: "Generate comprehensive strategic recommendations using advanced AI algorithms that analyze your SWOT and market position.",
  image: "https://pre-built-images.s3.amazonaws.com/webapp-uploads/5d045f96874dc5a7c94493f5a0375495.png",
  alt: "AI Strategy Generation Interface"
}, {
  title: "External Factor Analysis",
  description: "Evaluate opportunities and threats with weighted scoring system for comprehensive external environment assessment.",
  image: "https://pre-built-images.s3.amazonaws.com/webapp-uploads/d8b3555d87bf13de13be9e4ef96eaa5c.png",
  alt: "External Factor Evaluation Dashboard"
}, {
  title: "SWOT Analysis Framework",
  description: "Systematically identify and analyze your organization's Strengths, Weaknesses, Opportunities, and Threats.",
  image: "https://pre-built-images.s3.amazonaws.com/webapp-uploads/ab68db15e39dc9ddf918af037bd0c4e6.png",
  alt: "SWOT Analysis Interface"
}];
export function AppShowcaseSection() {
  return <section className="py-20 px-6 bg-gradient-to-br from-white to-muted" data-unique-id="6127c3ea-4f9b-4f1f-adef-7bd6b05e2385" data-file-name="components/app-showcase-section.tsx">
      <div className="max-w-7xl mx-auto" data-unique-id="1177b638-3610-4ecf-8e8f-106146f9bb26" data-file-name="components/app-showcase-section.tsx">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-unique-id="2372de21-cf3c-4e85-9f4c-230e652a85f4" data-file-name="components/app-showcase-section.tsx">
          <h2 className="text-4xl font-bold mb-4" data-unique-id="57dfb492-e980-4fbb-ab7a-53653cd06429" data-file-name="components/app-showcase-section.tsx"><span className="editable-text" data-unique-id="0a0843a3-f03c-4643-a079-601986bef0ba" data-file-name="components/app-showcase-section.tsx">
            See Acumena in </span><span className="gradient-text" data-unique-id="6daba0d5-b2c0-4565-bddc-c54e07ef7d3c" data-file-name="components/app-showcase-section.tsx"><span className="editable-text" data-unique-id="3633cd2e-8329-4169-a506-672788494212" data-file-name="components/app-showcase-section.tsx">Action</span></span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto" data-unique-id="bec471eb-7fe0-49ff-ac04-52f254bdb55f" data-file-name="components/app-showcase-section.tsx"><span className="editable-text" data-unique-id="5503c1f8-11bf-40b1-aaf2-e0d4eb3782a5" data-file-name="components/app-showcase-section.tsx">
            Real screenshots from our strategic management platform showing how businesses transform complex analysis into winning strategies
          </span></p>
        </motion.div>

        <div className="space-y-20" data-unique-id="fd44c4a4-8c4c-4988-8892-9929b78756f7" data-file-name="components/app-showcase-section.tsx" data-dynamic-text="true">
          {showcaseFeatures.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} viewport={{
          once: true
        }} className={`grid lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`} data-unique-id="5ce6619d-e38d-4fc0-8577-957bc589d389" data-file-name="components/app-showcase-section.tsx" data-dynamic-text="true">
              {/* Content */}
              <div className={`space-y-6 ${index % 2 === 1 ? 'lg:col-start-2' : ''}`} data-unique-id="f09a2ef7-bac6-4328-9cd3-409b6d98a87b" data-file-name="components/app-showcase-section.tsx">
                <div className="space-y-4" data-unique-id="3e99aafc-67e1-4cd3-a8e1-616b0b55a268" data-file-name="components/app-showcase-section.tsx">
                  <h3 className="text-2xl font-semibold" data-unique-id="67d4b4ff-c031-44a5-a807-4408e2628d3a" data-file-name="components/app-showcase-section.tsx" data-dynamic-text="true">{feature.title}</h3>
                  <p className="text-lg text-muted-foreground leading-relaxed" data-unique-id="c6c97a9b-6562-468d-bbc9-72d1488ba4b7" data-file-name="components/app-showcase-section.tsx" data-dynamic-text="true">
                    {feature.description}
                  </p>
                </div>
                
                <div className="flex items-center gap-4" data-unique-id="13e9b4c9-d67f-4577-b3ab-bc20f4324725" data-file-name="components/app-showcase-section.tsx">
                  <button className="gradient-button text-primary-foreground px-6 py-3 rounded-lg font-semibold" data-unique-id="32c60cbb-e082-41d2-996b-746c93241243" data-file-name="components/app-showcase-section.tsx"><span className="editable-text" data-unique-id="b05c1415-2bcb-466c-b613-5707d7bb27e7" data-file-name="components/app-showcase-section.tsx">
                    Try This Feature
                  </span></button>
                  <button className="text-primary font-semibold hover:text-primary-dark transition-colors" data-unique-id="910d312c-94bf-42e3-a625-c14e0657df9c" data-file-name="components/app-showcase-section.tsx"><span className="editable-text" data-unique-id="6e74fca3-bb1c-4967-a97b-986e52e22d78" data-file-name="components/app-showcase-section.tsx">
                    Learn More →
                  </span></button>
                </div>
              </div>

              {/* Screenshot */}
              <div className={`relative ${index % 2 === 1 ? 'lg:col-start-1' : ''}`} data-unique-id="548dd437-b7ac-4ab7-9f4a-13d69767dc88" data-file-name="components/app-showcase-section.tsx">
                <div className="relative bg-white rounded-2xl shadow-2xl border border-border overflow-hidden card-hover" data-unique-id="3c951b32-e06b-4d5d-ab53-832a1e6cb62c" data-file-name="components/app-showcase-section.tsx">
                  <img src={feature.image} alt={feature.alt} className="w-full h-auto" data-unique-id="9696c125-221b-4b46-bf7f-03442d5ceee0" data-file-name="components/app-showcase-section.tsx" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}